import {Controller} from 'stimulus';

export default class extends Controller {
  static targets = ['priceField', 'collapseSection', 'collapseButton',
    'warningBanner', 'validationError', 'extraSlotsToggle', 'extraSlotsRow',
    'imagesSection', 'imagesMoveTarget',
    'imageSlot1', 'imageSlot2', 'imageSlot3',
    'requiredLabel1', 'requiredLabel2', 'requiredLabel3'];

  static values = {
    threshold: Number,
    image2Required: Boolean,
    image3Required: Boolean,
  };

  connect() {
    this.imagesMoved = false;
    if (this.hasCollapseButtonTarget) {
      this.defaultButtonText = this.collapseButtonTarget.textContent.trim();
    }
    this.checkPrice();
  }

  priceChanged() {
    this.checkPrice();
  }

  checkPrice() {
    const price = this.currentPrice();
    const isHighValue = price >= this.thresholdValue;

    this.toggleRequiredIndicators(isHighValue);
    this.toggleWarningBanner(isHighValue);
    this.moveImagesSection(isHighValue);
    this.updateCollapseButtonText(isHighValue);
    this.hideValidationError();
  }

  currentPrice() {
    return parseFloat(
        this.priceFieldTarget.value.replace(',', '.')) || 0;
  }

  toggleRequiredIndicators(required) {
    this.toggleImageSlot(this.imageSlot1Target, this.requiredLabel1Target,
        required);

    if (this.image2RequiredValue) {
      this.toggleImageSlot(this.imageSlot2Target, this.requiredLabel2Target,
          required);
    }

    if (this.image3RequiredValue) {
      this.toggleImageSlot(this.imageSlot3Target, this.requiredLabel3Target,
          required);
    }
  }

  toggleImageSlot(slotTarget, labelTarget, required) {
    if (required) {
      slotTarget.classList.add('image-required');
      labelTarget.classList.remove('d-none');
    } else {
      slotTarget.classList.remove('image-required');
      labelTarget.classList.add('d-none');
    }
  }

  toggleWarningBanner(visible) {
    if (!this.hasWarningBannerTarget) return;

    if (visible) {
      this.warningBannerTarget.classList.remove('d-none');
    } else {
      this.warningBannerTarget.classList.add('d-none');
    }
  }

  moveImagesSection(aboveNotes) {
    if (!this.hasImagesSectionTarget || !this.hasImagesMoveTargetTarget) return;

    if (aboveNotes && !this.imagesMoved) {
      const saved = this.saveFiles();
      this.imagesMoveTargetTarget.appendChild(this.imagesSectionTarget);
      this.restoreFiles(saved);
      this.imagesMoved = true;
    } else if (!aboveNotes && this.imagesMoved) {
      const saved = this.saveFiles();
      this.collapseSectionTarget.querySelector('.premium-fields')
          .appendChild(this.imagesSectionTarget);
      this.restoreFiles(saved);
      this.imagesMoved = false;
    }
  }

  saveFiles() {
    const files = [];
    this.imagesSectionTarget
        .querySelectorAll('input[type="file"]').forEach((input) => {
          if (input.files && input.files.length > 0) {
            files.push({input, fileArray: Array.from(input.files)});
          }
        });
    return files;
  }

  restoreFiles(saved) {
    saved.forEach(({input, fileArray}) => {
      const dt = new DataTransfer();
      fileArray.forEach((file) => dt.items.add(file));
      input.files = dt.files;
    });
  }

  showExtraSlots() {
    if (!this.hasExtraSlotsRowTarget) return;

    this.extraSlotsRowTargets.forEach((row) => row.classList.remove('d-none'));
    this.extraSlotsToggleTarget.classList.add('d-none');
  }

  updateCollapseButtonText(short) {
    if (!this.hasCollapseButtonTarget) return;

    if (short) {
      this.collapseButtonTarget.textContent =
          this.collapseButtonTarget.dataset.imageRequirementShortText;
    } else {
      this.collapseButtonTarget.textContent = this.defaultButtonText;
    }
  }

  validateImages(event) {
    const price = this.currentPrice();
    if (price < this.thresholdValue) return;

    const missing = [];

    if (!this.hasFileSelected(this.imageSlot1Target)) {
      missing.push('1');
    }

    if (this.image2RequiredValue &&
        !this.hasFileSelected(this.imageSlot2Target)) {
      missing.push('2');
    }

    if (this.image3RequiredValue &&
        !this.hasFileSelected(this.imageSlot3Target)) {
      missing.push('3');
    }

    if (missing.length > 0) {
      event.preventDefault();
      event.stopPropagation();
      this.showValidationError(missing);
    }
  }

  showValidationError(missing) {
    if (!this.hasValidationErrorTarget) return;

    const template = this.validationErrorTarget.dataset.messageTemplate || '';
    const labels = missing.map((n) =>
      this.validationErrorTarget.dataset[`label${n}`] || `Afbeelding ${n}`);
    this.validationErrorTarget.textContent =
        template.replace('%{labels}', labels.join(', '));
    this.validationErrorTarget.classList.remove('d-none');
    this.validationErrorTarget.scrollIntoView(
        {behavior: 'smooth', block: 'center'});
  }

  hideValidationError() {
    if (!this.hasValidationErrorTarget) return;

    this.validationErrorTarget.classList.add('d-none');
  }

  hasFileSelected(slotElement) {
    const fileInput = slotElement.querySelector('input[type="file"]');
    return fileInput && fileInput.files && fileInput.files.length > 0;
  }
}
